import CancellationPolicy from "./components/Cancellation_policy";
import Navbar from "./components/Navbar";



function App() {
  return (
    <div className="App">
     <Navbar/>
     <CancellationPolicy/>
    </div>
  );
}

export default App;
